<template>
  <div v-if="!sorry">
  	<select class="form-control float-right" v-model.lazy="selectedCurrency">
      <option v-for="c in currencies" :value="c">{{c}}</option>
  	</select>
  	<h2>{{ $t("service.title") }}</h2>
  	<!-- <h2>Select Service</h2> -->
  	<hr>
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">{{ $t("service.loading") }}</span>
      </div>
    </div>
  	<ul v-if="!loading && !sorry" class="list-unstyled">
	  	<li  v-for="service in this.services" class="border border-secondary mb-2 p-3">
	  		<div class="media">
		  		<div class="img-box mr-3 rounded-circle border border-primary overflow-hidden">
				  <img :src="service.image" >
				</div>
			  <div class="media-body">
			    <h5 class="mt-0">{{service.name}}<br><small>{{service.minPax}}-{{service.maxPax}} PAX</small></h5>
			    {{service.description}}
			  </div>
	  		</div>
	  		<p class="text-center mt-1 mb-0">{{ $t("service.select") }}</p>
				<div class="row btn-selection no-gutters" >
					<div v-if="service.oneWay>0" class="col-6 col-sm-4">
					  <label class="btn" :class="[ selectedService==service.id+'-oneWay'?'active btn-primary':'btn-default' ]">
					    <input type="radio" name="serviceType" autocomplete="off" :value="{serviceName: service.name, value : service.id+'-oneWay'}" v-model="selectedService">
					    <h5>
					    	<strong>
                  <span v-if="service.oneWayDiscount > 0"> ${{service.oneWayDiscount}}
                    <small>{{service.currency}}</small>
                    <br>
                  </span>
                  <span :class="[{'text-line':service.oneWayDiscount > 0}]" >
							      ${{service.oneWay}} <small>{{service.currency}}</small><br>
                  </span>
							    <small>{{ $t("service.oneWay") }}</small>
					    	</strong>
					    </h5>
              <font-awesome-icon class="check" :icon="selectedService==service.id+'-oneWay'?'check-circle':farCircle" />
					  </label>
					</div>
					<div v-if="service.roundTrip>0" class="col-6 col-sm-4">
					  <label class="btn" :class="[ selectedService==service.id+'-roundTrip'?'active btn-primary':'btn-default' ]">
					    <input type="radio" name="serviceType" autocomplete="off" :value="{serviceName: service.name, value : service.id+'-roundTrip'}" v-model="selectedService">
					    <h5>
					    	<strong>
                  <span v-if="service.roundTripDiscount > 0"> ${{service.roundTripDiscount}}
                    <small>{{service.currency}}</small>
                    <br>
                  </span>
                  <span :class="[{'text-line':service.roundTripDiscount > 0}]">
							      ${{service.roundTrip}} <small>{{service.currency}}</small><br>
                  </span>
							    <small>{{ $t("service.roundTrip") }}</small>
					    	</strong>
					    </h5>
              <font-awesome-icon class="check" :icon="selectedService==service.id+'-roundTrip'?'check-circle':farCircle" />
					  </label>
					</div>
				</div>
		  	<!-- <div class="btn-group-toggle text-right mt-2" data-toggle="buttons"></div> -->
	  		<p class="text-right mb-0"><strong>{{ $t("service.taxes") }}</strong></p>
		  </li>
  	</ul>
    <Navigation></Navigation>
  </div>
  <Sorry v-else />
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Sorry from './Sorry.vue'
import Navigation from './Navigation.vue'
import {TripTypes} from '../js/constants.js'

export default {
  name: 'Services',
  components: {
    Sorry,
    Navigation
  },
  data: () => {
  	return {
      sorry: false,
      loading: true,
      farCircle: ['far', 'circle'],
      services: []
  	}
  },
  methods: {
    ...mapMutations(['currency', 'formFrom', 'formTo', 'formServiceType',
    'infoServiceType', 'infoTripType', 'toogleSessionTokenByType']),
    ...mapMutations({mutateTripType: 'tripType'}),
    getDetails(info) {
      return this.$http.get('places', {params: {place_id: info.placeId, sessionToken: info.googleApiSessionToken}});
    },
    getServices() {
      this.$http.post('prices/place', {...this.form}, {emulateJSON: true})
      .then((res) => {
        this.services = res.body;
        this.loading = false;
        this.sorry   = res.body.error;
      });
    },
    isAirport(place) {
      return place.placeId === this.defaultPlaceId;
    },
    recalculateTripType() {
      if (this.tripType === TripTypes.PlacePlace) {
        if (this.isAirport(this.fromPlace)) {
          this.mutateTripType(TripTypes.AirportPlace);
        } else if (this.isAirport(this.toPlace)) {
          this.mutateTripType(TripTypes.PlaceAirport);
        }
      }
    }
  },
  computed: {
    ...mapState(['hasSetting', 'settings', 'fromPlace', 'toPlace', 'form', 'info', 'tripType', 'defaultPlaceId']),
    selectedCurrency: {
      get() {
        return this.form.currency;
      },
      set(value) {
        this.currency(value);
        this.loading = true;
        this.getServices();
      }

    },
    selectedService: {
      get() {
        return this.form.serviceTypeID + '-' + this.form.tripType;
      },
      set(value) {
        const values = value.value.split('-');
        if (values.length == 2) {
          this.formServiceType({id: values[0], trip: values[1]});
          this.infoTripType(values[1]=='oneWay'?'One Way':'Round Trip');
        }
        // console.log("asdqq",value.serviceName);
        this.infoServiceType(value.serviceName)
      }
    },
    currencies() {
      if (this.hasSetting) {
        return this.settings.currencies;
      }
    },
  },
  mounted() {
    this.recalculateTripType();
    this.getDetails(this.fromPlace).then((res) => {
      this.toogleSessionTokenByType('from');
      this.formFrom(res.body.result);
      return this.getDetails(this.toPlace);
    }).then((res) => {
      this.toogleSessionTokenByType('to');
      this.formTo(res.body.result);
    }).then(this.getServices);
  }
}
</script>

<style scoped>
	h5{
		line-height: 16px;
	}
	strike{
		font-size: 14px;
	}
	select{
		width: 100px;
	}
	.media-body{
		font-size: 14px;
		line-height: 15px;
	}
	.img-box{
		width: 100px;
		height: 100px;
		justify-content: center;
		align-items: center;
		display: flex;
	}
	.media img{
		max-width: 100px;
	}
	.btn-selection label svg{
		display: block;
	}
	h5{
		margin-bottom: 0;
	}
  .text-line{
    font-size: 1rem;
    text-decoration: line-through;
  }
</style>
